import React, {useState, useEffect} from 'react'
import './App.css'
import './Cards'
import Cards from "./Cards";

const App = ({settings}) => {
  const [filteredVeterinarians, setFilteredVeterinarians] = useState(settings.veterinarians);
  const [selectedArea, setSelectedArea] = useState('');
  const [keyword, setKeyword] = useState('');
  const [selectedSkill, setSelectedSkill] = useState('');
  const handleAreaChange = (e) => {
    setSelectedArea(e.target.value)
  }
  const handleKeywordChange = (e) => {
    setKeyword(e.target.value)
  }

  const handleSkillChange = (e) => {
    setSelectedSkill(e.target.value)
  }

  useEffect(() => {
    const params = {
      area: selectedArea,
      skill: selectedSkill,
      keyword: keyword,
    }

    fetch("/veterinarians/search?" + (new URLSearchParams(params)).toString(), { headers: {'Content-Type': 'application/json'}})
      .then(response => response.json())
      .then((data) => {
        setFilteredVeterinarians(data)
      })
  }, [selectedSkill, selectedArea, keyword])

  return (
    <>
      <div className="banner_group">
        <h1 className="title">專業團隊</h1>
        <p className="txt">成為毛孩們健康後盾</p>
      </div>
      <div className="title_group">
        <div className="title icon_dr_title">醫師介紹<span>Doctor Introduction</span></div>
      </div>
      <div className="select_group">
        <input type="text" className="input_dr empty" placeholder="&#xF002; 請輸入 醫師名稱 / 院所名稱 / 專業科別"
               value={keyword} onChange={handleKeywordChange}/>

        <select className="select_hospital_group" value={selectedArea} onChange={handleAreaChange}>
          <option value="" selected>所有院所</option>
          {settings.areas.map((area) => (
            <option key={area.value} value={area.value}>{area.label}</option>
          ))}
        </select>
        <select className="select_department_group" value={selectedSkill} onChange={handleSkillChange}>
          <option value="" selected>專業科別</option>
          {settings.skills.map((skill) => (
            <option key={skill.value} value={skill.value}>{skill.label}</option>
          ))}
        </select>
      </div>
      <div className="drs_group">
        {filteredVeterinarians.length == 0 ? <h3 className="no-match-result">未有符合條件的醫師資訊</h3> : <Cards veterinarians={filteredVeterinarians} /> }
      </div>
    </>
  )
}

export default App
